export default {
    init() {
        // JavaScript to be fired on the checkout page
        let detailsToggleCheckbox = $('#ed-toggle-customer-details');

        detailsToggleCheckbox.click(function(){
            if($(detailsToggleCheckbox).is(':checked')) {
                $('.woocommerce-billing-fields').slideUp();
                $('.woocommerce-shipping-fields').slideUp();
            } else {
                $('.woocommerce-billing-fields').slideDown();
                $('.woocommerce-shipping-fields').slideDown();
            }
        });

        $('.expand-opt-out-section').click( function(e) {
          e.preventDefault();
          $('.checkout-opt-out-fields').slideDown();
        } );
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/checkout.js